<template>
    <div class="text-14 lg:text-16 bg-white rounded-10 px-3 py-3 lg:px-6 border border-a-brown-d7c7b8 cursor-pointer hover:border-a-brown-bba596"
        @click="clickDetail()">
        <div class="flex pb-1">
            <div class="text-a-brown-9f8273 mr-2">{{lbl.myOrder.history.order_no}}</div>
            <div class="text-a-brown-502314">{{ order.tranId }}</div>
        </div>
        <div class="flex pb-1">
            <div class="text-a-brown-9f8273 mr-2">{{lbl.myOrder.history.order_on}}</div>
            <div class="text-a-brown-502314">{{ getCreateDate(order.createDate) }}</div>
        </div>
        <div class="flex pb-1">
            <div class="text-a-brown-9f8273 mr-2">{{lbl.myOrder.history.total}}</div>
            <div class="text-a-brown-502314">{{ FilterNumberFormat(order.tranAmount) }} {{lbl.myOrder.history.bath}}</div>
        </div>
        <div class="flex pb-1">
            <div class="text-a-brown-9f8273 mr-2">{{lbl.myOrder.history.status}}</div>
            <div :class="[statusTextColor]">{{ mapTextStatus }}</div>
        </div>
    </div>
</template>

<script>
import DatetimeHelper from "@/helper/DatetimeHelper.js";
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
export default {
    name: "OrderItem",
    mixins: [LocaleMixin],
    props: {
        order: { type: Object, required: true }
    },
    emits: ["onClick"],
    computed: {
        mapTextStatus: function () {
            if (this.order.vendorStatus == 1) {
                return this.lbl.myOrder.statusOrderPlaced;
            } else if (this.order.vendorStatus == 2) {
                return this.lbl.myOrder.statusOnRoute;
            } else if (this.order.vendorStatus == 3) {
                return this.lbl.myOrder.statusOrderComplete;
            } else if (this.order.vendorStatus == 5) {
                return this.lbl.myOrder.statusReadyToPick;
            } else if (this.order.vendorStatus == 6) {
                return this.lbl.myOrder.statusPickedUp;
            } else if (this.order.vendorStatus == -1) {
                return this.lbl.myOrder.statusCanceled;
            } else {
                return this.order.vendorStatusName;
            }
        },
        statusTextColor: function () {
            if (this.order.vendorStatus == 1) {
                return "text-a-orange-ff8732";
            } else if (this.order.vendorStatus == 2) {
                return "text-a-orange-ff8732";
            } else if (this.order.vendorStatus == 3) {
                return "text-a-green-198737";
            } else if (this.order.vendorStatus == 5) {
                return "text-a-green-198737";
            } else if (this.order.vendorStatus == 6) {
                return "text-a-green-198737";
            } else if (this.order.vendorStatus == -1) {
                return "text-a-red-d62300";
            } else {
                return "text-a-brown-502314";
            }
        }
    },
    methods: {
        getCreateDate: function (createDate) {
            return DatetimeHelper.timestampFullFormat(createDate) + " | " + DatetimeHelper.timeFormatShort2(createDate);
        },
        clickDetail: function () {
            this.$router.push({
                name: ""
            })
        }
    }
}
</script>

<style>
</style>
